export const replaceNewlines = (search: string): string =>
  search.replace(/[\n\t\r]/, '');
